// AI专用无感传输：沿用公共请求的鉴权约定，不引入全局Loading或请求内容日志。
import axios from 'axios'
import vm from '@/main'
import store from 'store/index'
import { handleExpiredSession } from '@/common/auth-navigation'

export function aiLightRequest(config) {
  const instance = axios.create({ timeout: 15000, headers: { 'Content-Type': 'application/json' } })
  instance.interceptors.response.use(response => {
    if (response.data && response.data.code === 6)
      handleExpiredSession(vm, store, { ...response.config, authToken: config.data.token }, response.data.message)
    return response
  })
  return instance(config)
}
